export function imgSrcParser(
  src?: string | null,
  backendUrl: string = window?.runConfig?.backendUrl ?? ''
): string {
  if (!src) return '';

  const trimmedSrc = src.trim();

  if (/^(blob:|data:)/i.test(trimmedSrc)) return trimmedSrc;

  try {
    return new URL(trimmedSrc).href;
  } catch {}

  if (!backendUrl) return trimmedSrc;

  const base = backendUrl.replace(/\/+$/, '') + '/';

  try {
    return new URL(trimmedSrc.replace(/^\/+/, ''), base).href;
  } catch {
    return base + trimmedSrc.replace(/^\/+/, '');
  }
}
